module.exports = __webpack_public_path__ + "img/Logo_cx_pos_blanco.a349dfa2.png";